/* eslint-disable no-param-reassign */
// eslint-disable-next-line import/no-extraneous-dependencies
import { produce } from 'immer';
import { preconfiguredConfirmationModalClick } from '../../../analytics';

export default (set, get) => set(produce(get(), (draft) => {
  if (!draft.digitalData) {
    draft.digitalData = { event: [] };
  }
  preconfiguredConfirmationModalClick();
}), false, { type: 'TRACK_PRECONFIGURED_CONFIRMATION_MODAL_CLICK' });
